export function SlackIcon({ className }: { className?: string }) {
    return (
      <svg 
        className={className} 
        width="36" 
        height="36" 
        viewBox="0 0 36 36" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_slack)">
          <path 
            d="M7.57167 22.6857C7.57167 24.7714 5.88595 26.4572 3.80024 26.4572C1.71452 26.4572 0.0288086 24.7714 0.0288086 22.6857C0.0288086 20.6 1.71452 18.9143 3.80024 18.9143H7.57167V22.6857ZM9.45738 22.6857C9.45738 20.6 11.1431 18.9143 13.2288 18.9143C15.3145 18.9143 17.0002 20.6 17.0002 22.6857V32.1143C17.0002 34.2 15.3145 35.8857 13.2288 35.8857C11.1431 35.8857 9.45738 34.2 9.45738 32.1143V22.6857Z" 
            fill="#E01E5A" 
          />
          <path 
            d="M13.2286 7.54286C11.1429 7.54286 9.45714 5.85714 9.45714 3.77143C9.45714 1.68571 11.1429 0 13.2286 0C15.3143 0 17 1.68571 17 3.77143V7.54286H13.2286ZM13.2286 9.45714C15.3143 9.45714 17 11.1429 17 13.2286C17 15.3143 15.3143 17 13.2286 17H3.77143C1.68571 17 0 15.3143 0 13.2286C0 11.1429 1.68571 9.45714 3.77143 9.45714H13.2286Z" 
            fill="#36C5F0" 
          />
          <path 
            d="M28.3426 13.2286C28.3426 11.1429 30.0283 9.45714 32.1141 9.45714C34.1998 9.45714 35.8855 11.1429 35.8855 13.2286C35.8855 15.3143 34.1998 17 32.1141 17H28.3426V13.2286ZM26.4569 13.2286C26.4569 15.3143 24.7712 17 22.6855 17C20.5998 17 18.9141 15.3143 18.9141 13.2286V3.77143C18.9141 1.68571 20.5998 0 22.6855 0C24.7712 0 26.4569 1.68571 26.4569 3.77143V13.2286Z" 
            fill="#2EB67D" 
          />
          <path 
            d="M22.6855 28.3429C24.7712 28.3429 26.4569 30.0286 26.4569 32.1143C26.4569 34.2 24.7712 35.8857 22.6855 35.8857C20.5998 35.8857 18.9141 34.2 18.9141 32.1143V28.3429H22.6855ZM22.6855 26.4572C20.5998 26.4572 18.9141 24.7714 18.9141 22.6857C18.9141 20.6 20.5998 18.9143 22.6855 18.9143H32.1426C34.2283 18.9143 35.9141 20.6 35.9141 22.6857C35.9141 24.7714 34.2283 26.4572 32.1426 26.4572H22.6855Z" 
            fill="#ECB22E" 
          />
        </g>
        <defs>
          <clipPath id="clip0_slack">
            <rect width="36" height="36" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    )
  }